import { Button, Card, Checkbox, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import {
  deleteResponsable,
  updateSaveResponsable,
} from "../ResponsablesSlice/Responsables.slice";
import CustomForm from "../../../components/CustomForm";
import React, { useRef, useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { onlyRoleMapping, userHasLevel } from "../../../../engine/AuthRoute";
import routes from "../../../../engine/routes";
import { modalApplicantIntervenantInputs } from "../../../components/CreateApplicant/ModalApplicantIntervenantInputs";
import { renderResponsable } from "../../../../utils/constants";

export const ResponsableItem = ({
  responsable,
  defaultId = null,
  isChecked,
  institution,
  principal,
  isNew = false,
}) => {
  const { _id } = responsable;

  const formRef = useRef(null);

  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);

  const deleteItem = () => {
    dispatch(deleteResponsable(responsable));
    // if (isChecked) {
    //   changeDefault(null);
    // }
  };

  const {
    principal: principalAdress,
    institution: institutionAdress,
    email,
    lastname,
    firstname,
    phone,
    role,
  } = responsable;

  const handleSubmit = data => {
    // data.address.external = data.address.external === "on";
    data._id = responsable._id;
    const update = dispatch(updateSaveResponsable(data));
  };

  const changeEdition = () => {
    setIsEdit(!isEdit);
  };

  // const addressPrincipalToInstitution = () => {
  //   if (
  //     institution !== null &&
  //     address.principal !== null &&
  //     address.institution === null
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // const isAdressShared = () => {
  //   if (address.principal !== null) {
  //     return false;
  //   }
  //
  //   if (
  //     address.institution !== null &&
  //     address.institution._id !== institution._id
  //   ) {
  //     return true;
  //   }
  //
  //   return false;
  // };

  const userCanUpdate = userHasLevel(routes.institutions().responsables, "u");

  const userCanChangeAddress = () => {
    // if (isAdressShared()) {
    //   return true;
    // }

    // if (addressPrincipalToInstitution()) {
    //   return true;
    // } else {
    //   return !userCanUpdate;
    // }

    return !userCanUpdate;
  };

  const renderText = () => {
    return (
      <strong>
        {phone}
        <br />
        {email}
      </strong>
    );
  };

  return (
    <>
      <Card
        key={_id}
        title={<>{renderResponsable(responsable)}</>}
        extra={[
          <Button
            disabled={userCanChangeAddress()}
            onClick={changeEdition}
            size={"small"}
            type={"primary"}
            style={{ marginRight: 10 }}
          >
            {isEdit ? "Annuler" : "Modifier"}
          </Button>,
          <Popconfirm
            disabled={!isEdit && userCanChangeAddress()}
            title="Supprimer ce responsable"
            description="Êtes-vous sûr de vouloir supprimer ce responsable ?"
            onConfirm={deleteItem}
            onCancel={() => {}}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              disabled={!isEdit && userCanChangeAddress()}
              size={"small"}
              type={"primary"}
            >
              Supprimer
            </Button>
          </Popconfirm>,
        ]}
      >
        {isEdit ? (
          <CustomForm
            refForm={formRef}
            disabled={!userCanUpdate}
            dataSource={modalApplicantIntervenantInputs({
              setOpen: changeEdition,
              name: "intervenant",
              update: true,
              values: responsable,
            })}
            labelCol={24}
            wrapperCol={24}
            handleSubmit={handleSubmit}
          />
        ) : (
          renderText()
        )}
      </Card>
    </>
  );
};
